import { api } from "@/lib/api";

export const adminStatsApi = {
  summary: () => api.get("/admin/stats/summary").then((r) => r.data),
  navCounts: () => api.get("/admin/stats/nav-counts").then((r) => r.data),
  finance: () => api.get("/admin/stats/finance").then((r) => r.data),
  operations: () => api.get("/admin/stats/operations").then((r) => r.data),
};
